import { __exports as shared } from "./index226.js";
import { __require as requireMerge } from "./index114.js";
var hasRequiredShared;
function requireShared() {
  if (hasRequiredShared) return shared;
  hasRequiredShared = 1;
  Object.defineProperty(shared, "__esModule", {
    value: true
  });
  shared.getTotalWidthOfEncodings = shared.calculateEncodingAttributes = shared.getBarcodePadding = shared.getEncodingHeight = shared.getMaximumHeightOfEncodings = void 0;
  var _merge = requireMerge();
  var _merge2 = _interopRequireDefault(_merge);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function getEncodingHeight(encoding, options) {
    return options.height + (options.displayValue && encoding.text.length > 0 ? options.fontSize + options.textMargin : 0) + options.marginTop + options.marginBottom;
  }
  function getBarcodePadding(textWidth, barcodeWidth, options) {
    if (options.displayValue && barcodeWidth < textWidth) {
      if (options.textAlign == "center") {
        return Math.floor((textWidth - barcodeWidth) / 2);
      } else if (options.textAlign == "left") {
        return 0;
      } else if (options.textAlign == "right") {
        return Math.floor(textWidth - barcodeWidth);
      }
    }
    return 0;
  }
  function calculateEncodingAttributes(encodings, barcodeOptions, context) {
    for (var i = 0; i < encodings.length; i++) {
      var encoding = encodings[i];
      var options = (0, _merge2.default)(barcodeOptions, encoding.options);
      var textWidth;
      if (options.displayValue) {
        textWidth = messureText(encoding.text, options, context);
      } else {
        textWidth = 0;
      }
      var barcodeWidth = encoding.data.length * options.width;
      encoding.width = Math.ceil(Math.max(textWidth, barcodeWidth));
      encoding.height = getEncodingHeight(encoding, options);
      encoding.barcodePadding = getBarcodePadding(textWidth, barcodeWidth, options);
    }
  }
  function getTotalWidthOfEncodings(encodings) {
    var totalWidth = 0;
    for (var i = 0; i < encodings.length; i++) {
      totalWidth += encodings[i].width;
    }
    return totalWidth;
  }
  function getMaximumHeightOfEncodings(encodings) {
    var maxHeight = 0;
    for (var i = 0; i < encodings.length; i++) {
      if (encodings[i].height > maxHeight) {
        maxHeight = encodings[i].height;
      }
    }
    return maxHeight;
  }
  function messureText(string, options, context) {
    var ctx;
    if (context) {
      ctx = context;
    } else if (typeof document !== "undefined") {
      ctx = document.createElement("canvas").getContext("2d");
    } else {
      return 0;
    }
    ctx.font = options.fontOptions + " " + options.fontSize + "px " + options.font;
    var measureTextResult = ctx.measureText(string);
    if (!measureTextResult) {
      return 0;
    }
    var size = measureTextResult.width;
    return size;
  }
  shared.getMaximumHeightOfEncodings = getMaximumHeightOfEncodings;
  shared.getEncodingHeight = getEncodingHeight;
  shared.getBarcodePadding = getBarcodePadding;
  shared.calculateEncodingAttributes = calculateEncodingAttributes;
  shared.getTotalWidthOfEncodings = getTotalWidthOfEncodings;
  return shared;
}
export {
  requireShared as __require
};
//# sourceMappingURL=index215.js.map
